import './catalog.scss';
import addClass from '../utils/dom/addClass';
import addToCart from '../utils/addToCart';
import click from '../utils/dom/click';
import removeClass from '../utils/dom/removeClass';

const ON = 'on';

const catalog = () => {
  const images = [...document.querySelectorAll('.section-catalog-image:not(.ghost)')];
  const total = images.length;
  let current = 0;
  let loading = 0;

  const preload = () => {
    if (loading === total) {
      return;
    }

    addClass(images[loading].querySelector('img'), 'lazypreload');
    loading = loading + 1;
    // preload();
  };

  const onImageClick = (newCurrent) => {
    removeClass(images[current], ON);

    if (newCurrent === total) {
      newCurrent = 0;
    }

    current = newCurrent;
    addClass(images[current], ON);

    preload();
  };

  images.forEach((image, idx) => {
    image.addEventListener(click(), () => {
      onImageClick(idx + 1);
    });
  });

  preload();
  preload();

  // Update the add to bag button to add to bag when clicked.
  const catalog = document.querySelector('.section-catalog-actions');
  const addToBagButton = document.querySelector('.section-catalog-actions .add-to-bag-button');

  addToBagButton.addEventListener(click(), async () => {
    await addToCart(addToBagButton, { id: catalog.dataset.variantid });
  });
};

const addImages = () => {
  const { catalogImages } = window.HMR;
  const target = document.querySelector('.catalog-images');

  if (!target || !catalogImages) {
    return;
  }
  target.innerHTML = target.innerHTML + catalogImages.join('');
  // catalogImages.forEach((image) => {
  //   console.info('image', image);
  // });
};

addImages();
catalog();
